import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Customer {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  company?: string;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  customer: Customer | null;
  isAuthenticated: boolean;
  
  setTokens: (accessToken: string, refreshToken: string) => void;
  setAccessToken: (accessToken: string) => void;
  setCustomer: (customer: Customer) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      customer: null,
      isAuthenticated: false,
      
      setTokens: (accessToken, refreshToken) =>
        set({ accessToken, refreshToken, isAuthenticated: true }),
      
      setAccessToken: (accessToken) =>
        set({ accessToken }),
      
      setCustomer: (customer) =>
        set({ customer }),
      
      logout: () =>
        set({
          accessToken: null,
          refreshToken: null,
          customer: null,
          isAuthenticated: false,
        }),
    }),
    {
      name: 'customer-auth-storage',
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        customer: state.customer,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
